import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, " 스트레스 케어 ", -1)
const _hoisted_5 = { class: "board_wrap" }
const _hoisted_6 = { class: "board_search_box" }
const _hoisted_7 = { class: "board_category" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "",
                id: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.list.search) = $event)),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchContents && $setup.searchContents(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, $setup.list.search]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchContents && $setup.searchContents(...args)))
              }, "검색")
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.selectTag(0))),
                class: _normalizeClass($setup.state.selectCategoryIdx === -1 ? 'active' : '')
              }, " 전체 ", 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.category, (tag, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass($setup.state.selectCategoryIdx === index ? 'active' : ''),
                  onClick: ($event: any) => ($setup.selectTag(index + 1))
                }, _toDisplayString(tag.name), 11, _hoisted_8))
              }), 256))
            ]),
            _createVNode(_component_DataGrid, {
              list: $setup.list.data,
              columns: $setup.list.fields,
              totalLength: $setup.list.length,
              isShowPageBtn: true,
              perPage: $setup.list.size,
              "current-page": $setup.list.currentPage,
              onOnRowClick: $setup.moveDetail,
              onOnPaging: $setup.handlePageChange,
              onOnNextPage: $setup.handlePageChange,
              onOnPrevPage: $setup.handlePageChange,
              onOnFirstPage: $setup.handlePageChange,
              onOnLastPage: $setup.handlePageChange
            }, null, 8, ["list", "columns", "totalLength", "perPage", "current-page", "onOnRowClick", "onOnPaging", "onOnNextPage", "onOnPrevPage", "onOnFirstPage", "onOnLastPage"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      content: $setup.state.modalContent,
      onClose: $setup.modalClose
    }, null, 8, ["show", "content", "onClose"])
  ], 64))
}